'use client'

import {useEffect, useRef, useState} from 'react'
import clsx from 'clsx'
import s from './style.module.scss'

type Props = {
  children: React.ReactNode
}

// Right side only sticky if the screen height is greater than component height.
const StickyRightSide = ({children}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isStickyAllowed, setIsStickyAllowed] = useState(false)

  useEffect(() => {
    const updateStickiness = () => {
      const container = containerRef.current
      if (!container) return

      const containerHeight = container.offsetHeight
      const viewportHeight = window.innerHeight - 90 // 90px header height

      setIsStickyAllowed(containerHeight < viewportHeight)
    }

    updateStickiness()
    window.addEventListener('resize', updateStickiness)

    return () => {
      window.removeEventListener('resize', updateStickiness)
    }
  }, [])

  return (
    <div
      ref={containerRef}
      className={clsx({
        [s.sticky_container]: isStickyAllowed,
      })}
    >
      {children}
    </div>
  )
}

export default StickyRightSide
